export default __webpack_public_path__ + "static/media/google-logo.8a2f665b.svg";